import React from "react";
import styled from "styled-components/native";
import CarouselItem from "./CarouselItem";
import { CarouselProps } from "./types";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTheme } from "styled-components/native";
import { css } from "styled-components/native";
import { DefaultTheme } from "styled-components/native";

const CarouselThumbs = ({
  testIDPrefix = "pdp.gallery.thumbs",
  data,
  itemDetail,
  activeIndex,
  vertical,
  image_thumb_url,
  changeActiveIndex,
  thumbColor,
  thumbSize,
  thumbResizeMode,
  thumbDefaultBorderColor,
  style,
  imageWidth,
  iconSize,
}: CarouselProps) => {
  const theme = useTheme();

  if ((data?.length ?? 0) < 2) return null;

  return (
    <StyledScrollView imageWidth={imageWidth} horizontal={!theme.isLargeScreen}>
      <StyledView vertical={vertical} style={style}>
        {data.map((image, index) => {
          return (
            <CarouselItem
              key={`${image.type}-${index}`}
              testID={`${testIDPrefix}.thumb.${index}`}
              item={image}
              itemDetail={itemDetail}
              index={index}
              activeIndex={activeIndex}
              image_thumb_url={image_thumb_url}
              changeActiveIndex={changeActiveIndex}
              thumbColor={thumbColor}
              thumbSize={thumbSize}
              thumbResizeMode={thumbResizeMode}
              thumbDefaultBorderColor={thumbDefaultBorderColor}
              iconSize={iconSize}
            />
          );
        })}
      </StyledView>
    </StyledScrollView>
  );
};

const StyledScrollView = styled.ScrollView<{ imageWidth: number }>`
  flex: 1;
  padding-inline: ${SpaceType.Basic}px;
  height: ${({
    imageWidth,
    theme,
  }: {
    imageWidth: number;
    theme: DefaultTheme;
  }) => (theme.isLargeScreen ? `${imageWidth}px` : "100%")};
  max-width: ${({ theme }: { theme: DefaultTheme }) =>
    !theme.isLargeScreen ? `400px` : "100%"};
  ${({ theme }: { theme: DefaultTheme }) =>
    theme.isLargeScreen &&
    !theme.isMobile &&
    css`
      transform: scaleX(1);
    `}
`;

const StyledView = styled.View<{ vertical: boolean; width: number }>`
  flex: 1;
  flex-basis: auto;
  flex-direction: ${({ vertical }: { vertical: boolean }) =>
    vertical ? "column" : "row"};
  gap: ${({ width }: { width: number }) =>
    width > 1920 ? `${SpaceType.Double}px` : `${SpaceType.Basic}px`};
`;

export default React.memo(CarouselThumbs);
